import { nanoid, customAlphabet } from 'nanoid/non-secure';

function __uniqid__() {
  const UNIQUE_IDS = {};

  function __id__(length, alphanum = false) {
    if (arguments.length === 1 && arguments[0] === true) {
      alphanum = true;
    }

    length = (Number.isInteger(length) && length > 0) ? length : 10;

    const __generated__ = ((alphanum === true)
      ? customAlphabet('1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ', length * 3)
      : nanoid.bind(null, length * 3)
    )();

    return __generated__
      .replace(/_/g, '-')
      .replace(/(^[-\d]+?|-+?$)/g, '')
      .slice(0, length);
  }

  return (__uniqid__ = function __uniqid__() {
    let id = __id__();
    while (id in UNIQUE_IDS && (id = __id__()));
    return (UNIQUE_IDS[id] = 1, id);
  })();
}

// common
export const SWITCH_CURRENCY = __uniqid__();
export const SWITCH_PAYMENT_METHOD = __uniqid__();
export const UPDATE_PAYMENT_METHODS = __uniqid__();
export const START_SWITCH_CURRENCY = __uniqid__();
export const STOP_SWITCH_CURRENCY = __uniqid__();
export const START_PROCESSING = __uniqid__();
export const STOP_PROCESSING = __uniqid__();
export const UPDATE_CHARGE_AMOUNT = __uniqid__();
export const UPDATE_DCC_DATA = __uniqid__();
export const UPDATE_ERROR_MESSAGE = __uniqid__();
export const UPDATE_DARK_MODE = __uniqid__();
export const UPDATE_SYSTEM_COLOR_OVERRIDE = __uniqid__();
export const UPDATE_BACKGROUND_PROCESSING = __uniqid__();
export const UPDATE_LOCALE = __uniqid__();
export const UPDATE_INFO = __uniqid__();
export const UPDATE_CAMPAIGN = __uniqid__();
export const SET_SESSION_EXPIRY = __uniqid__();
export const SET_SESSION_EXPIRED = __uniqid__();

// payment
export const UPDATE_PAYMENT_DATA = __uniqid__();
// export const RESET_PAYMENT_ERROR = __uniqid__();
// export const UPDATE_PAYMENT_ERROR = __uniqid__();
// export const START_PAYMENT_WAITING = __uniqid__();
// export const STOP_PAYMENT_WAITING = __uniqid__();
